export class InaccessibleResourceError extends Error {
	public constructor(public cause?: unknown) {
		super('Resource is not accessible');
		this.name = 'InaccessibleResourceError';
	}
}
